import { useApp } from '../../context/AppContext';
import { Label } from '../ui/label';
import { SliderInput } from './SliderInput';
import { Baby, User } from 'lucide-react';

export const ChildFutureInputs = () => {
  const { inputs, updateInput, t, language } = useApp();
  const maturityAge = (inputs.childAge || 0) + (inputs.years || 0);

  return (
    <div className="p-5 rounded-2xl bg-pink-50 dark:bg-pink-900/20 border-2 border-pink-200 dark:border-pink-800 space-y-5">
      <div className="flex items-center gap-2 mb-1">
        <Baby className="h-5 w-5 text-pink-600 dark:text-pink-400" />
        <span className="text-sm font-semibold text-pink-800 dark:text-pink-200">
          {t('childPlanTitle')}
        </span>
      </div>

      <SliderInput
        label={t('childAge')}
        value={inputs.childAge ?? 3}
        onChange={(v) => updateInput('childAge', v)}
        min={0} max={17} step={1}
        suffix={language === 'ro' ? ' ani' : ' years'}
        testId="child-age"
      />
      <SliderInput
        label={t('parentAge')}
        value={inputs.parentAge ?? 35}
        onChange={(v) => updateInput('parentAge', v)}
        min={20} max={65} step={1}
        suffix={language === 'ro' ? ' ani' : ' years'}
        testId="parent-age"
      />

      <div className="mt-2 p-3 rounded-xl bg-pink-100 dark:bg-pink-900/40 text-sm text-pink-700 dark:text-pink-300 flex items-center gap-2">
        <User className="h-4 w-4 flex-shrink-0" />
        <span>
          {t('childAtMaturity')} <strong>{maturityAge}</strong> {t('yearsAtEnd')}
        </span>
      </div>
    </div>
  );
};

export default ChildFutureInputs;
